export const version = {
    major: 1,
    minor: 5,
    patch: 113
}
